module.exports = __webpack_public_path__ + "media/day/263-e22a0d73.svg";